/* eslint-disable react-hooks/exhaustive-deps */
import { memo, useState, useRef, useEffect } from "react";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CarForm from "./CarType/Car";
import TruckForm from "./CarType/Truck";
import CoachForm from "./CarType/Coach";
import SpecializedVehicleForm from "./CarType/SpecializedVehicle";
import SelectedInput from "Components/FormComponents/SelectedInput";
import UploadRegion from "Components/MainBodyV2/CarType/uploadRegion";
import { usePollingStatus } from "hooks/usePollingUntilSuccess";
import {
  getPriceOnRoad,
  getPriceVolatility,
  getCarEstimatePrice,
  getPrice,
  getPriceV3,
} from "../../MainBody/api";
import {
  ResultCarPrice,
  onRoadPriceResult,
  CarPriceInflation,
  carEstimatePrice,
} from "../types";
import { useLocation } from "react-router-dom";
import { options } from "./CarType/constant";
import { ChildRef } from "Components/MainBodyV2/CarType/type";
import { passParamIntoCarValue } from "Common/common";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";
import { CAR, TRUCK, COACH, SPECIALIZED, OTHER } from "./CarType/constant";

const FormAICycle = ({
  carPriceValue,
  setCarPriceValue,
  setOnRoadPrice,
  setPriceVolatility,
  setCarEstimatedPrice,
  isLoadCarPrice,
  setIsLoadCarPrice,
  setErrorVolatility,
  setErrorEstimated,
  registerPlace,
  jobId,
  setJobId,
}: {
  carPriceValue: ResultCarPrice;
  setCarPriceValue: React.Dispatch<React.SetStateAction<ResultCarPrice>>;
  setOnRoadPrice: React.Dispatch<React.SetStateAction<onRoadPriceResult>>;
  setPriceVolatility: React.Dispatch<React.SetStateAction<CarPriceInflation[]>>;
  setCarEstimatedPrice: React.Dispatch<React.SetStateAction<carEstimatePrice>>;
  isLoadCarPrice: boolean;
  setIsLoadCarPrice: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorVolatility: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorEstimated: React.Dispatch<React.SetStateAction<boolean>>;
  registerPlace: string;
  jobId: string | null;
  setJobId: React.Dispatch<React.SetStateAction<string | null>>;
}) => {
  const theme = useTheme();
  const { state } = useLocation();
  const [dataStringify, setDataStringify] = useState<string>("");
  const typeLocal = localStorage.getItem("type");
  const value = !typeLocal ? CAR : typeLocal;
  const [type, setType] = useState(value);
  const carFormRef = useRef<ChildRef>(null);
  const [files, setFiles] = useState([]);
  const [fileOthers, setFileOthers] = useState([]);
  const [paper, setPaper] = useState("two");
  const [dataFormImage, setDataFromImage] = useState<any>(null);

  const handleClear = () => {
    carFormRef.current?.triggerAction();
  };
  const { dataPolling, error } = usePollingStatus(jobId);

  useEffect(() => {
    if (error) {
      setJobId(null);
      setIsLoadCarPrice(false);
    }
  }, [error]);

  useEffect(() => {
    if ((state && !state?.carValue) || state?.type === "car")
      valuationApi(state);
  }, [state]);

  useEffect(() => {
    if (state?.carValue && state?.minPrice && state?.maxPrice)
      setCarPriceValue((prev) => ({
        ...prev,
        carValue: state?.carValue,
        minPrice: state?.minPrice,
        maxPrice: state?.maxPrice,
      }));
  }, []);

  const valuationApi = async (object: any) => {
    const {
      company,
      model,
      manufactureyear,
      version,
      optionKey,
      originId,
      kmTraveled,
      date,
    } = object;
    if (type === CAR) {
      try {
        setIsLoadCarPrice(true);

        const valueGetCarPrice: any = passParamIntoCarValue(
          company,
          model,
          manufactureyear,
          version,
          optionKey,
          originId,
          kmTraveled,
          date,
        );

        const getCarPrice = await getPrice(valueGetCarPrice);
        setTimeout(() => setIsLoadCarPrice(false), 1000);
        setCarPriceValue(getCarPrice);
      } catch (error: any) {
        setIsLoadCarPrice(false);
        setCarPriceValue((prev) => ({
          ...prev,
          maxPrice: null,
          carValue: null,
          minPrice: null,
        }));
        toast.error(error?.response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }

      try {
        const volatilityPrice = await getPriceVolatility(
          version.key ? version.key : "",
        );
        setPriceVolatility(volatilityPrice);
        setErrorVolatility(false);
      } catch (error) {
        setErrorVolatility(true);
      }

      try {
        const carEstimatedPrice = await getCarEstimatePrice(
          version.key ? version.key : "",
        );
        setCarEstimatedPrice(carEstimatedPrice);
        setErrorEstimated(false);
      } catch (error) {
        setErrorEstimated(true);
      }
      if (version.id !== OTHER && !date) {
        try {
          const value = await getPriceOnRoad(
            version.key!,
            registerPlace,
            optionKey.key,
          );
          setOnRoadPrice(value);
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      try {
        setIsLoadCarPrice(true);
        const getCarPrice = await getPriceV3({
          vehicleTypeKey: localStorage.getItem("type"),
          companyName:
            object.company.id === OTHER
              ? object.company.label
              : object.company.id,
          versionName: object.model.versionKey ?? object.model.label,
          manufactureYear: object.selectedManufactured.id,
          ...(localStorage.getItem("type") === TRUCK && {
            barrelTypeKey: object.selectedBarrelType.id,
          }),
          ...(object.modelCode.id === OTHER
            ? { modelCode: "khac" }
            : { modelCode: object.modelCode.id }),
          ...(object.modelCode.id === OTHER && {
            modelCodeFromUser: object.otherValue,
          }),
          ...(object.modelCode.id === OTHER && { enableFallback: true }),
          ...(date && { targetDate: date }),
        });
        if (object.modelCode.id !== OTHER) {
          setTimeout(() => setIsLoadCarPrice(false), 1000);
        }
        if (object.modelCode.id === OTHER) {
          if (getCarPrice?.meta?.jobId) {
            setJobId(getCarPrice?.meta?.jobId ?? null);
            setCarPriceValue({
              ...carPriceValue,
              maxPrice: null,
              carValue: null,
              minPrice: null,
            });
            setIsLoadCarPrice(true);
            return;
          } else {
            setTimeout(() => setIsLoadCarPrice(false), 1000);
            setCarPriceValue({
              carCompany: "",
              carModel: "",
              carVersion: "",
              year: "",
              maxPrice: getCarPrice.maxPrice ?? null,
              carValue: getCarPrice.carValue ?? getCarPrice.price ?? null,
              minPrice: getCarPrice.minPrice ?? null,
              isWarning: false,
              listedPrice: null,
              minListedPrice: null,
              maxListedPrice: null,
              manufacturerListPrice: getCarPrice.manufacturerListPrice ?? null,
              hanoiOnRoadPrice: null,
              generalOnRoadPrice: null,
              hcmOnRoadPrice: null,
              additions: [],
              sessionId: getCarPrice.sessionId,
              isAiGenerated: getCarPrice.isAiGenerated ?? false,
            });
            return;
          }
        } else {
          if (getCarPrice?.meta?.jobId) {
            setJobId(getCarPrice?.meta?.jobId ?? null);
            setCarPriceValue({
              ...carPriceValue,
              maxPrice: null,
              carValue: null,
              minPrice: null,
            });
            setIsLoadCarPrice(true);
            return;
          }
          setCarPriceValue({
            carCompany: "",
            carModel: "",
            carVersion: "",
            year: "",
            maxPrice: getCarPrice.maxPrice ?? null,
            carValue: getCarPrice.carValue ?? getCarPrice.price ?? null,
            minPrice: getCarPrice.minPrice ?? null,
            isWarning: false,
            listedPrice: null,
            minListedPrice: null,
            maxListedPrice: null,
            manufacturerListPrice: getCarPrice.manufacturerListPrice ?? null,
            hanoiOnRoadPrice: null,
            generalOnRoadPrice: null,
            hcmOnRoadPrice: null,
            additions: [],
            sessionId: getCarPrice.sessionId,
            isAiGenerated: getCarPrice.isAiGenerated ?? false,
          });
        }
      } catch (error: any) {
        setIsLoadCarPrice(false);
      }
    }
  };

  useEffect(() => {
    if (dataFormImage) {
      const { carValue, minPrice, maxPrice } = dataFormImage;
      if (carValue && minPrice && maxPrice)
        setCarPriceValue((prev) => ({
          ...prev,
          carValue: carValue,
          minPrice: minPrice,
          maxPrice: maxPrice,
        }));
    }
  }, [dataFormImage]);

  useEffect(() => {
    if (dataPolling?.status === 200) {
      setIsLoadCarPrice(false);
      setCarPriceValue({
        carCompany: "",
        carModel: "",
        carVersion: "",
        year: "",
        maxPrice: dataPolling?.data?.maxPrice ?? null,
        carValue:
          dataPolling?.data?.carValue ?? dataPolling?.data?.price ?? null,
        minPrice: dataPolling?.data?.minPrice ?? null,
        isWarning: false,
        listedPrice: null,
        minListedPrice: null,
        maxListedPrice: null,
        manufacturerListPrice: null,
        hanoiOnRoadPrice: null,
        generalOnRoadPrice: null,
        hcmOnRoadPrice: null,
        additions: [],
        isAiGenerated: dataPolling?.data?.isAiGenerated ?? false,
      });
      setJobId(null);
    }
    if (dataPolling?.data?.meta?.status === "FAILED") {
      setIsLoadCarPrice(false);
      setCarPriceValue({
        carCompany: "",
        carModel: "",
        carVersion: "",
        year: "",
        maxPrice: null,
        carValue: null,
        minPrice: null,
        isWarning: false,
        listedPrice: null,
        minListedPrice: null,
        maxListedPrice: null,
        manufacturerListPrice: null,
        hanoiOnRoadPrice: null,
        generalOnRoadPrice: null,
        hcmOnRoadPrice: null,
        additions: [],
      });
      setJobId(null);
    }
  }, [dataPolling]);

  const handleValueChange = (value: string) => {
    setDataStringify(value);
  };

  const initialValues = {
    carCompanyId: "",
  };

  /* event click button Tra cứu */
  const handleSubmit = async () => {
    localStorage.setItem(type, dataStringify);
    const object = JSON.parse(dataStringify);
    const {
      company,
      model,
      manufactureyear,
      version,
      optionKey,
      originId,
      kmTraveled,
      date,
    } = JSON.parse(dataStringify);

    if (type === CAR) {
      try {
        //Run api evaluate car price
        setIsLoadCarPrice(true);

        const valueGetCarPrice: any = passParamIntoCarValue(
          company,
          model,
          manufactureyear,
          version,
          optionKey,
          originId,
          kmTraveled,
          date,
        );

        const getCarPrice = await getPrice(valueGetCarPrice);
        setTimeout(() => setIsLoadCarPrice(false), 1000);
        setCarPriceValue(getCarPrice);
      } catch (error: any) {
        setIsLoadCarPrice(false);
        setCarPriceValue((prev) => ({
          ...prev,
          maxPrice: null,
          carValue: null,
          minPrice: null,
        }));
        toast.error(error?.response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }

      // get api chart price car for current year and next 3 year
      try {
        const volatilityPrice = await getPriceVolatility(
          version.key ? version.key : "",
        );
        setPriceVolatility(volatilityPrice);
        setErrorVolatility(false);
      } catch (error) {
        setErrorVolatility(true);
      }

      // average price next 3 year
      try {
        const carEstimatedPrice = await getCarEstimatePrice(
          version.key ? version.key : "",
        );
        setCarEstimatedPrice(carEstimatedPrice);
        setErrorEstimated(false);
      } catch (error) {
        setErrorEstimated(true);
      }
      // get car price onroad
      if (version.id !== OTHER && !date) {
        try {
          const value = await getPriceOnRoad(
            version.key!,
            registerPlace,
            optionKey.key,
          );
          setOnRoadPrice(value);
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      try {
        //Run api evaluate car price
        setIsLoadCarPrice(true);
        const getCarPrice = await getPriceV3({
          vehicleTypeKey: localStorage.getItem("type"),
          companyName:
            object.company.id === OTHER
              ? object.company.label
              : object.company.id,
          versionName: object.model.versionKey ?? object.model.label,
          manufactureYear: object.selectedManufactured.id,
          ...(localStorage.getItem("type") === TRUCK && {
            barrelTypeKey: object.selectedBarrelType.id,
          }),
          ...(object.modelCode.id === OTHER
            ? { modelCode: "khac" }
            : { modelCode: object.modelCode.id }),
          ...(object.modelCode.id === OTHER && {
            modelCodeFromUser: object.otherValue,
          }),
          ...(object.modelCode.id === OTHER && { enableFallback: true }),
          ...(date && { targetDate: date }),
        });
        if (object.modelCode.id !== OTHER) {
          setTimeout(() => setIsLoadCarPrice(false), 1000);
        }
        if (object.modelCode.id === OTHER) {
          if (getCarPrice?.meta?.jobId) {
            setJobId(getCarPrice?.meta?.jobId ?? null);
            setCarPriceValue({
              ...carPriceValue,
              maxPrice: null,
              carValue: null,
              minPrice: null,
            });
            setIsLoadCarPrice(true);
            return;
          } else {
            setTimeout(() => setIsLoadCarPrice(false), 1000);
            setCarPriceValue({
              carCompany: "",
              carModel: "",
              carVersion: "",
              year: "",
              maxPrice: getCarPrice.maxPrice ?? null,
              carValue: getCarPrice.carValue ?? getCarPrice.price ?? null,
              minPrice: getCarPrice.minPrice ?? null,
              manufacturerListPrice: getCarPrice.manufacturerListPrice ?? null,
              isWarning: false,
              listedPrice: null,
              minListedPrice: null,
              maxListedPrice: null,
              hanoiOnRoadPrice: null,
              generalOnRoadPrice: null,
              hcmOnRoadPrice: null,
              additions: [],
              sessionId: getCarPrice.sessionId,
              isAiGenerated: getCarPrice.isAiGenerated ?? false,
            });
            return;
          }
        } else {
          if (getCarPrice?.meta?.jobId) {
            setJobId(getCarPrice?.meta?.jobId ?? null);
            setCarPriceValue({
              ...carPriceValue,
              maxPrice: null,
              carValue: null,
              minPrice: null,
            });
            setIsLoadCarPrice(true);
            return;
          }
          setCarPriceValue({
            carCompany: "",
            carModel: "",
            carVersion: "",
            year: "",
            maxPrice: getCarPrice.maxPrice ?? null,
            carValue: getCarPrice.carValue ?? getCarPrice.price ?? null,
            minPrice: getCarPrice.minPrice ?? null,
            isWarning: false,
            listedPrice: null,
            minListedPrice: null,
            maxListedPrice: null,
            manufacturerListPrice: getCarPrice.manufacturerListPrice ?? null,
            hanoiOnRoadPrice: null,
            generalOnRoadPrice: null,
            hcmOnRoadPrice: null,
            additions: [],
            sessionId: getCarPrice.sessionId,
            isAiGenerated: getCarPrice.isAiGenerated ?? false,
          });
        }
      } catch (error: any) {
        setIsLoadCarPrice(false);
        setCarPriceValue((prev) => ({
          ...prev,
          maxPrice: null,
          carValue: null,
          minPrice: null,
        }));
        toast.error(error?.response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    }
  };

  return (
    <Formik
      onSubmit={() => {
        handleSubmit();
      }}
      initialValues={initialValues}
    >
      {() => {
        return (
          <Form>
            <Grid
              container
              pl={3}
              gap={0.5}
              sx={{
                backgroundColor:
                  theme.palette.mode === "dark" ? "#21262C" : "unset",
              }}
            >
              <SelectedInput
                label="Loại xe"
                idForInput="carType"
                listOption={options}
                value={type}
                onChange={setType}
                setDataFromImage={setDataFromImage}
                setCarPriceValue={setCarPriceValue}
                setFiles={setFiles}
                setFileOthers={setFileOthers}
              />
              <UploadRegion
                files={files}
                fileOthers={fileOthers}
                dataFormImage={dataFormImage}
                paper={paper}
                setFileOthers={setFileOthers}
                setFiles={setFiles}
                setPaper={setPaper}
                setDataFromImage={setDataFromImage}
                setCarType={setType}
                handleClear={handleClear}
              />
              {type === CAR && (
                <CarForm
                  ref={carFormRef}
                  isLoadCarPrice={isLoadCarPrice}
                  dataFormImage={dataFormImage}
                  onValueChange={handleValueChange}
                  setDataFromImage={setDataFromImage}
                  setCarPriceValue={setCarPriceValue}
                />
              )}
              {type === TRUCK && (
                <TruckForm
                  ref={carFormRef}
                  isLoadCarPrice={isLoadCarPrice}
                  dataFormImage={dataFormImage}
                  onValueChange={handleValueChange}
                  setDataFromImage={setDataFromImage}
                  setCarPriceValue={setCarPriceValue}
                />
              )}
              {type === SPECIALIZED && (
                <SpecializedVehicleForm
                  ref={carFormRef}
                  isLoadCarPrice={isLoadCarPrice}
                  dataFormImage={dataFormImage}
                  onValueChange={handleValueChange}
                  setDataFromImage={setDataFromImage}
                  setCarPriceValue={setCarPriceValue}
                />
              )}
              {type === COACH && (
                <CoachForm
                  ref={carFormRef}
                  isLoadCarPrice={isLoadCarPrice}
                  dataFormImage={dataFormImage}
                  onValueChange={handleValueChange}
                  setDataFromImage={setDataFromImage}
                  setCarPriceValue={setCarPriceValue}
                />
              )}
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

export default memo(FormAICycle);
